<template>
  <div id="orgHYl">我是第一个chart</div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.chartPartFun();
  },
  methods: {
    //画图
    chartPartFun() {
      var chart = echarts.init(document.getElementById("orgHYl"));
      var option = {
        top: 25,
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        grid: {
          left: "16px",
          right: "0px",
          top: "25px",
          bottom: "25px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },

        yAxis: {
          type: "value",
          axisLine: {
            show: false
          }
        },
        series: [
          {
            data: [0, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            symbolSize: 8,
            symbol: "circle", //拐点设置为实心
            smooth: true,
            itemStyle: {
              normal: {
                color: "#E062AE"
              }
            },
            areaStyle: {
              //渐变色
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#E062AE" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            } //填充区域样式
          }
        ]
      };

      chart.setOption(option);
      window.addEventListener("resize", () => {
        chart.resize();
      });
    }
  }
};
</script>